<template>
    <div id="navbar">
        <div class="logo">
            <router-link to="/welcome">
                <img :src="logo" alt="logo WealthPlanner">
            </router-link>
        </div>

        <div class="menu">
            <router-link to="/gestion">Missions</router-link>
            <router-link to="/conseillers/crm">Suivi commercial</router-link>
            <router-link to="/academy-learner">Academie</router-link>
        </div>

        <div class="administrator" @click="toggleParameters">
            {{ $store.getters.getUserInitials }}
        </div>

        <div class="parameters" v-if="showParameters">
            <div @click="logout">
                <span>Deconnexion</span>
                <span class="material-symbols-outlined">logout</span>
            </div>

            <teleport to="#site-wrapper">
                <div class="overlay" @click="toggleParameters"></div>
            </teleport>
        </div>
    </div>
</template>

<script>
import logo from '@/assets/images/LBF_logo.svg';

export default {
    data() {
        return {
            logo: logo,
            showParameters: false,
            showBurgerMenu: false,
            errMsg: "",
        }
    },
    methods: {
        toggleParameters() {
            this.showParameters = !this.showParameters
        },
        async logout() {
            this.showParameters = false;
            await this.$store.dispatch('logout');
            this.$router.replace('/welcome');
        },
    },
    watch: {
        errMsg() {
            this.$store.commit('changeErrorMsg', this.errMsg)
        }
    },
}
</script>

<style scoped>
#navbar {
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    height: 80px;
    box-sizing: border-box;
    box-shadow: 0 5px 10px -2px #F5F6FA;
}

.logo {
    cursor: pointer;
    display: flex;
    flex-direction: column;
}

.logo a {
    text-decoration: none;
}

.logo img {
    height: 50px;
}

.menu {
    display: flex;
    justify-content: right;
    align-items: center;
    flex-basis: 100%;
}

.menu a {
    color: #1C1C1E;
    font-size: 18px;
    text-decoration: none;
    margin: 0 20px;
}

.menu a:hover {
    color: #29B6CE;
}

.menu .router-link-active {
    color: #29B6CE;
}

.administrator {
    cursor: pointer;
    margin-right: 20px;
    color: white;
    font-weight: bold;
    background-color: #1C1C1E;
    padding: 10px;
    border: 5px solid #1C1C1E;
    border-radius: 50%;
}

.overlay {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(128, 128, 128, 0.361);

}

.parameters {
    z-index: 2;
    position: absolute;
    top: 80px;
    right: 0px;
    background-color: white;
}

.parameters div {
    cursor: pointer;
    padding: 10px;
    min-width: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.parameters div:hover {
    color: #29B6CE;
}

.parameters div span {
    cursor: pointer;
}



@media screen and (max-width: 800px) {

    .administrator {
        cursor: pointer;
        position: absolute;
        right: -5px;
        padding: 10px;
        font-size: 10px;
    }

    .menu a {
        font-size: 10px;
        margin: 5px 10px;
    }
}
</style>